"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vowels = {
    a: true,
    e: true,
    i: true,
    o: true,
    u: true,
};
var prefixWithArticle = function (word) {
    if (vowels[word[0].toLowerCase()]) {
        return 'an ' + word;
    }
    else {
        return 'a ' + word;
    }
};
exports.default = prefixWithArticle;
